__webpack_require__.p = "/getting-started/account-setup/";